import { ApolloCache } from "@apollo/client/cache";
ApolloCache.prototype.evictQueries = function (queries) {
    queries.forEach(q => {
        var _a, _b;
        // @ts-ignore
        const operationName = toCamlCase((_b = (_a = q.query.definitions.find(d => d.kind === "OperationDefinition")) === null || _a === void 0 ? void 0 : _a.name) === null || _b === void 0 ? void 0 : _b.value);
        console.debug(`evicting cache for ${operationName}`);
        if (operationName) {
            this.evict({ fieldName: operationName, args: q.variables });
        }
    });
    this.gc();
};
const toCamlCase = (value) => {
    if (value) {
        return value.slice(0, 1).toLowerCase() + value.slice(1);
    }
    return value;
};
//# sourceMappingURL=eviction.js.map